import React from 'react';
import { css } from '@emotion/react';
import { PaddingStyle } from 'styles/PaddingStyle';
import { formatPrice } from 'utils/utils';
import { theme } from 'styles/theme';
import { usePrice } from 'hooks/usePrice';

export const InputPrice = ({
	value,
	onChange,
	sizeMedium,
	width,
	error,
	isVAT,
	placeholder,
	showVATCalculation,
}: {
	value: number;
	onChange: (e: any) => void;
	sizeMedium?: boolean;
	width: number;
	error?: boolean;
	isVAT?: boolean;
	placeholder?: string;
	showVATCalculation?: boolean;
}) => {
	const { withVAT, withoutVAT, VAT } = usePrice({ price: value });

	return (
		<div>
			<input
				css={css`
					height: ${sizeMedium ? 36 : 44}px;
					border: 1px solid #d4d5de;
					border-radius: 8px;
					width: ${width ? width + 'px' : '100%'};
					padding: 12px;
					font-size: 14px;
					line-height: 20px;

					::placeholder {
						color: #8c8fa6;
					}

					&:focus {
						outline: none;
						box-shadow: 0 0 0 2px ${theme.color.primary['400']};
						border-color: transparent;
					}

					${!!error &&
					css`
						border-color: #ff6767;
					`}
				`}
				placeholder={placeholder}
				type="number"
				value={value}
				onChange={(e) => onChange(e.target.value ? parseFloat(e.target.value) : null)}
			/>
			<span
				css={[
					PaddingStyle({ l: 12 }),
					css`
						font-size: 13px;
						color: ${theme.color.text['300']};
					`,
				]}
			>
				<strong>CZK</strong> {isVAT && 'bez DPH'}
			</span>
			{isVAT && showVATCalculation && !error && (
				<>
					<div
						css={css`
							font-size: 13px;
							padding-top: 8px;
							color: ${theme.color.text['300']};
						`}
					>
						<strong>s DPH:</strong> {formatPrice(withVAT)}
					</div>

					<div
						css={css`
							font-size: 13px;
							color: ${theme.color.text['300']};
						`}
					>
						<strong>DPH:</strong> {formatPrice(VAT)}
					</div>
				</>
			)}
		</div>
	);
};
